import { BasicButton, IconLibrary, LoadingSpinner, ThriveIcon } from "thrive-components";

//hook
import UseApprovePanel from "./ApprovePanel.hooks";

import "../../../../../css/activityFeed/elements/approve-panel.scss";



interface IApprovePanel {className?:string, needsApproval?: boolean, onApprovalClick: any}

const ApprovePanel = ({className, needsApproval, onApprovalClick} : IApprovePanel) => {

    const {
        isLoading, 
        onButtonClick, 
        needsApprovedText, 
        approvedStateText, 
        pendingApproveStateText, 
        pendingApproveStateAriaLabel, 
        loadingAriaLabel
    } = UseApprovePanel({onApprovalClick});

    if (needsApproval) {
        return (
            <div className={`approval-panel needs-approval-panel ${className ?? ""}`}>
                <div className="left">
                    <ThriveIcon 
                        iconName={IconLibrary.ALERT_INFO} 
                        color="var(--thriveLightSlate)" 
                        sizeInPx="14"
                    />
                    
                   {needsApprovedText}
                </div>

                {isLoading 
                    ?   <BasicButton 
                            content={<LoadingSpinner size={10} />} 
                            ariaLabel={loadingAriaLabel} 
                            className="loading-approval-panel-button" 
                        />

                    :   <BasicButton 
                            content={pendingApproveStateText} 
                            isDisabled={isLoading} 
                            ariaLabel={pendingApproveStateAriaLabel} 
                            onButtonClick={onButtonClick} 
                            className="approval-panel-button" 
                        />
                }
            </div>
        )
    }
        return (
            <div className={`approval-panel approved-panel ${className ?? ""}`}>
                <ThriveIcon iconName={IconLibrary.CHECK_DOUBLE} color="var(--thriveSky)" sizeInPx="12"/> {approvedStateText}
            </div>
        )

};

export default ApprovePanel